import * as e from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/CirclesThree.es.js";
const r = e.forwardRef((o, c) => /* @__PURE__ */ e.createElement(s, { ref: c, ...o, weights: t }));
r.displayName = "CirclesThreeIcon";
const m = r;
export {
  m as CirclesThree,
  r as CirclesThreeIcon
};
